// extracted by mini-css-extract-plugin
module.exports = {"link":"DisabledNavLink_link__3MCIZ","disabled":"DisabledNavLink_disabled__2SEeg","link--active":"DisabledNavLink_link--active__1KjFQ"};